var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHeartOff = function SvgHeartOff(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9062 4.51019C17.6484 2.61176 14.1602 2.89691 12 5.09613C9.83984 2.89691 6.35156 2.60785 4.09375 4.51019C1.15626 6.98285 1.58594 11.0141 3.67969 13.1508L10.5312 20.1313C10.9219 20.5297 11.4453 20.7524 12 20.7524C12.5586 20.7524 13.0781 20.5336 13.4687 20.1352L20.3203 13.1547C22.4101 11.018 22.8476 6.98675 19.9062 4.51019ZM18.9844 11.8344L12.1328 18.8149C12.0391 18.9086 11.9609 18.9086 11.8672 18.8149L5.01563 11.8344C3.58985 10.3813 3.30078 7.63128 5.30078 5.94769C6.82031 4.67035 9.16406 4.86176 10.6328 6.35785L12 7.75238L13.3672 6.35785C14.8437 4.85394 17.1875 4.67035 18.6992 5.94379C20.6953 7.62738 20.3984 10.393 18.9844 11.8344Z",
    fill: "#F44336"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeartOff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/heart_off.0129f92e.svg";
export { ForwardRef as ReactComponent };